const PATH_CG = 'cg';
export const PLP_PATHS = ['search', 'category', 'plp', PATH_CG];
const MEMBERSHIP_PATHS = ['membershipenroll', 'membership'];
const NON_STATIC_PATHS = ['product', 'cart', 'myCoupons', ...PLP_PATHS, ...MEMBERSHIP_PATHS];
const STATIC_PATHS = ['deals', 'home', 'not-found'];
const MEMBERSHIP_ENROLL_PATHS = [
  '/membership/club',
  '/membership/clubplus',
  '/membership/business',
  '/membership/businessplus',
  '/membership/clubcardenroll',
  '/membership/clubcardenroll/clubpluscard',
  '/membership/businessenroll',
  '/membership/businessenroll/clubpluscard',
];

export const MFE_ROUTES = {
  product: 'pdpMfe',
  cart: 'cartMfe',
  myCoupons: 'couponsMfe',
  category: 'plpMfe',
  search: 'plpMfe',
  staticRoute: 'staticMfe',
  membership: 'membershipMfe',
};
export const COMMON_MFES = ['footerMfe', 'sharedMfe', 'headerMfe'];

export function checkSlug(paths: string[] = [], currentRoute = '', isShopAll = false) {
  return paths.some((path) => {
    if (currentRoute === PATH_CG) {
      return isShopAll && currentRoute === path;
    }
    return currentRoute === path;
  });
}

export function isValidStaticMfePath(currentRoute = '', isShopAll = false) {
  return (
    STATIC_PATHS.includes(currentRoute) || !checkSlug(NON_STATIC_PATHS, currentRoute, isShopAll)
  );
}

export const isMembershipEnrollURL = (url) => MEMBERSHIP_ENROLL_PATHS.includes(url.toLowerCase());

export const isValidMembershipPath = (currentRoute = '') =>
  MEMBERSHIP_PATHS.includes(currentRoute) || isMembershipEnrollURL(currentRoute);

export function isBrowser() {
  return typeof window !== 'undefined';
}

export function getQueryParamFromUrl(key = '') {
  try {
    return isBrowser() ? (new URLSearchParams(window.location.search).get(key) ?? '') : '';
  } catch (e) {
    console.warn('Unable to get query parameter from URL', e);
    return '';
  }
}
